/* =====================================================
   ZYVORA SKINCARE — THEME JS
   ===================================================== */

/* ── Global Cart State (exposed for cross-IIFE access) ── */
var cartData = { items: [], total_price: 0, item_count: 0 };

function fetchCart() {
  return fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      cartData = data;
      updateCartUI();
      return data;
    });
}

function formatMoney(cents) {
  return 'Rs. ' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 0 });
}

function updateCartUI() {
  var count = cartData.item_count || 0;
  var countEls = document.querySelectorAll('.zv-cart-count');
  countEls.forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
  renderCartItems();
  renderCartSubtotal();
}

function renderCartItems() {
  var container = document.querySelector('.zv-cart-items');
  if (!container) return;

  if (!cartData.items || cartData.items.length === 0) {
    container.innerHTML = '<div class="zv-cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><h4>Your cart is empty</h4><p>Discover your perfect skincare ritual</p></div>';
    return;
  }

  container.innerHTML = cartData.items.map(function(item) {
    return '<div class="zv-cart-item" data-key="' + item.key + '">' +
      '<div class="zv-cart-item-img"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy"></div>' +
      '<div class="zv-cart-item-info">' +
        '<p class="zv-cart-item-title">' + item.product_title + '</p>' +
        '<p class="zv-cart-item-price">' + formatMoney(item.final_line_price) + '</p>' +
        '<div class="zv-qty-row">' +
          '<button class="zv-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" onclick="zvQty(this)">−</button>' +
          '<span class="zv-qty-num">' + item.quantity + '</span>' +
          '<button class="zv-qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" onclick="zvQty(this)">+</button>' +
        '</div>' +
      '</div>' +
      '<button class="zv-cart-remove" data-key="' + item.key + '" onclick="zvRemove(this)">Remove</button>' +
    '</div>';
  }).join('');
}

function renderCartSubtotal() {
  var el = document.querySelector('.zv-cart-total-price');
  if (el) el.textContent = formatMoney(cartData.total_price || 0);

  var freeShip = document.querySelector('.zv-cart-free-ship');
  if (freeShip) {
    freeShip.textContent = '🚚 Free delivery on your order!';
    freeShip.style.color = '#3C151D';
    freeShip.style.fontWeight = '500';
  }
}

function openCartDrawer() {
  var overlay = document.querySelector('.zv-cart-overlay');
  var drawer = document.querySelector('.zv-cart-drawer');
  if (overlay) overlay.classList.add('open');
  if (drawer) {
    drawer.classList.add('open');
    // Re-render items AFTER drawer is open so container is visible in DOM
    setTimeout(function() {
      renderCartItems();
      renderCartSubtotal();
    }, 50);
  }
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  var overlay = document.querySelector('.zv-cart-overlay');
  var drawer = document.querySelector('.zv-cart-drawer');
  if (overlay) overlay.classList.remove('open');
  if (drawer) drawer.classList.remove('open');
  document.body.style.overflow = '';
}

function addToCart(variantId, quantity, btn) {
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) || 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  })
  .then(function(data) {
    cartData = data;
    updateCartUI();
    openCartDrawer();
    showNotify('Added to cart!');
    if (btn) {
      btn.textContent = '✓ Added!';
      setTimeout(function() {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 2000);
    }
  })
  .catch(function() {
    showNotify('Something went wrong. Please try again.');
    if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
  });
}

function showNotify(msg) {
  var el = document.querySelector('.zv-notify');
  if (!el) {
    el = document.createElement('div');
    el.className = 'zv-notify';
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg><span></span>';
    document.body.appendChild(el);
  }
  el.querySelector('span').textContent = msg;
  el.classList.add('show');
  clearTimeout(el._timer);
  el._timer = setTimeout(function() { el.classList.remove('show'); }, 3500);
}

/* ── Cart quantity & remove (global) ── */
window.zvQty = function(btn) {
  var key = btn.dataset.key;
  var qty = parseInt(btn.dataset.qty);
  if (qty < 0) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) { cartData = data; updateCartUI(); });
};

window.zvRemove = function(btn) {
  var key = btn.dataset.key;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) { cartData = data; updateCartUI(); showNotify('Item removed from cart'); });
};

/* ═══════════════════════════════════
   DOM READY — INIT ALL
   ═══════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function() {

  /* ── Header scroll ── */
  var header = document.querySelector('.zv-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ── Mobile Menu ── */
  var hamburger = document.querySelector('.zv-hamburger');
  var mobileMenu = document.querySelector('.zv-mobile-menu');
  var mobileClose = document.querySelector('.zv-mobile-close');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() { mobileMenu.classList.add('open'); });
    if (mobileClose) mobileClose.addEventListener('click', function() { mobileMenu.classList.remove('open'); });
    mobileMenu.addEventListener('click', function(e) { if (e.target === mobileMenu) mobileMenu.classList.remove('open'); });
  }

  /* ── Cart Drawer ── */
  var overlay = document.querySelector('.zv-cart-overlay');
  var closeBtn = document.querySelector('.zv-cart-close');
  var continueBtn = document.querySelector('.zv-cart-continue');
  var checkoutBtn = document.querySelector('.zv-cart-checkout');

  if (overlay) overlay.addEventListener('click', closeCartDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeCartDrawer);
  if (checkoutBtn) checkoutBtn.addEventListener('click', function() { window.location.href = '/checkout'; });

  document.querySelectorAll('[data-open-cart]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      fetchCart().then(function() { openCartDrawer(); });
    });
  });

  /* ── Add to Cart — all forms (product cards + PDP) ── */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.classList.contains('zv-card-form') && form.id !== 'zv-product-form') return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    e.preventDefault();
    var variantId = idInput.value;
    var qty = form.querySelector('input[name="quantity"]') ? form.querySelector('input[name="quantity"]').value : 1;
    var btn = form.querySelector('button[type="submit"]');
    addToCart(variantId, qty, btn);
  });

  /* ── Accordions ── */
  document.querySelectorAll('.zv-acc-trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.zv-acc-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.zv-acc-item.open').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── FAQ ── */
  document.querySelectorAll('.zv-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.zv-faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.zv-faq-item.open').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── Product Gallery ── */
  var thumbs = document.querySelectorAll('.zv-thumb');
  var mainImg = document.querySelector('.zv-gallery-main img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        if (this.dataset.src) mainImg.src = this.dataset.src;
      });
    });
  }

  /* ── Newsletter form ── */
  document.querySelectorAll('.zv-nl-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]');
      if (!email || !email.value) return;
      showNotify('Thank you for subscribing!');
      form.reset();
    });
  });

  /* ── Contact form ── */
  var contactForm = document.querySelector('.zv-contact-form-el');
  if (contactForm) {
    contactForm.addEventListener('submit', function(e) {
      e.preventDefault();
      showNotify("Message sent! We'll reply within 24 hours.");
      contactForm.reset();
    });
  }

  /* ── Lazy load animation ── */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.zv-section, .zv-product-card, .zv-combo-card, .zv-step, .zv-concern-item').forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

  /* ── Initial cart fetch ── */
  fetchCart();
});

/* ═══════════════════════════════════
   HERO SLIDER
   ═══════════════════════════════════ */
(function() {
  var slides = document.querySelectorAll('.zv-slide');
  var dots   = document.querySelectorAll('.zv-dot');
  var prev   = document.querySelector('.zv-slider-prev');
  var next   = document.querySelector('.zv-slider-next');
  if (!slides.length) return;

  var current = 0;
  var timer;
  var INTERVAL = 5000;

  function goTo(n) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
  }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(function() { goTo(current + 1); }, INTERVAL);
  }

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); startTimer(); });
  });
  if (prev) prev.addEventListener('click', function() { goTo(current - 1); startTimer(); });
  if (next) next.addEventListener('click', function() { goTo(current + 1); startTimer(); });

  var startX = 0;
  var slider = document.querySelector('.zv-hero-slider');
  if (slider) {
    slider.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { goTo(dx < 0 ? current + 1 : current - 1); startTimer(); }
    }, { passive: true });
  }

  startTimer();
})();

/* ═══════════════════════════════════
   STICKY ATC — PRODUCT PAGE
   ═══════════════════════════════════ */
(function() {
  var mainAtc = document.querySelector('.zv-product-atc');
  if (!mainAtc) return;

  var titleEl = document.querySelector('.zv-product-title');
  var priceEl = document.querySelector('.zv-product-price');
  var variantInput = document.querySelector('#zv-product-form input[name="id"]');
  if (!titleEl || !priceEl || !variantInput) return;

  var bar = document.createElement('div');
  bar.className = 'zv-sticky-atc';
  bar.innerHTML =
    '<div class="zv-sticky-atc-inner">' +
    '<span class="zv-sticky-atc-title">' + titleEl.textContent + '</span>' +
    '<span class="zv-sticky-atc-price">' + priceEl.textContent + '</span>' +
    '<button class="zv-sticky-atc-btn">Add to Cart</button>' +
    '</div>';
  document.body.appendChild(bar);

  bar.querySelector('.zv-sticky-atc-btn').addEventListener('click', function() {
    var btn = this;
    var variantId = variantInput.value;
    var qty = document.getElementById('zv-pdp-qty') ? document.getElementById('zv-pdp-qty').value : 1;
    addToCart(variantId, qty, btn);
  });

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      bar.classList.toggle('visible', !entry.isIntersecting);
    });
  }, { threshold: 0.1 });
  io.observe(mainAtc);
})();